import AccountModel from '@/models/Accounting/AccAccount'

const createAccounts = async data => {
    let acc = new AccountModel(data)
    try {
        let response = await acc.save()
        return response
    } catch (error) {
        return error.response
    }
}

export default createAccounts
